import { memo, useCallback } from 'react'

const LEFT_RAIL_W = 200

interface MixerRulerProps {
  playheadTime: number
  videoDuration: number
  onSeek: (timeS: number) => void
}

export const MixerRuler = memo(function MixerRuler({ playheadTime, videoDuration, onSeek }: MixerRulerProps) {
  const handleClick = useCallback((e: React.MouseEvent<HTMLDivElement>) => {
    const rect = e.currentTarget.getBoundingClientRect()
    const frac = Math.max(0, Math.min(1, (e.clientX - rect.left) / rect.width))
    onSeek(frac * videoDuration)
  }, [videoDuration, onSeek])

  const ticks = []
  const count = Math.ceil(videoDuration) + 1
  for (let i = 0; i < count; i++) {
    const isMajor = i % 5 === 0
    const showLabel = i % 2 === 0
    ticks.push(
      <div key={i} className="absolute top-0" style={{ left: `${(i / videoDuration) * 100}%`, height: '100%' }}>
        <div className={`w-px ${isMajor ? 'h-full bg-white/[0.18]' : 'h-[40%] bg-white/[0.06]'}`} />
        {showLabel && (
          <span className="absolute top-[5px] left-1 text-[9px] font-mono text-text-muted">{i}s</span>
        )}
      </div>,
    )
  }

  const playheadPct = videoDuration > 0 ? (playheadTime / videoDuration) * 100 : 0

  return (
    <div className="relative h-6 bg-surface-1 border-b border-border flex shrink-0">
      <div className="flex-shrink-0 border-r border-border" style={{ width: LEFT_RAIL_W }} />
      <div className="flex-1 relative cursor-pointer" onClick={handleClick}>
        {ticks}
        {/* Playhead */}
        <div className="absolute top-0 bottom-0 z-[2] pointer-events-none" style={{ left: `${playheadPct}%` }}>
          <div className="w-px h-full bg-red-500" />
          <div
            className="absolute top-0 -translate-x-1/2 w-0 h-0"
            style={{ borderLeft: '5px solid transparent', borderRight: '5px solid transparent', borderTop: '8px solid #ef4444' }}
          />
        </div>
      </div>
    </div>
  )
})

export { LEFT_RAIL_W }
